<template>
  <Layout>
    <FilterPanel :modelValue="filter" @update:modelValue="setFilter" />
    <div class="indicators layout--horizontal">
      <section class="box box--small-padding" style="min-width: 800px">
        <h2 class="box__header title-24">Общие показатели</h2>
        <div class="layout--horizontal">
          <FetchJson :url="urls.documentRegisteredTotalUnfiltered.value">
            <template #default="{ json, loading }">
              <ScalarIndicator
                v-if="!loading"
                title="Размещено документов"
                :value="json.value"
              ></ScalarIndicator>
            </template>
          </FetchJson>
          <FetchJson :url="urls.documentPendingRegistration.value">
            <template #default="{ json, loading }">
              <div v-show="filter.mode === modes.allTime">
                <ScalarIndicator
                  v-if="!loading"
                  title="Ожидают размещения"
                  :value="json.value"
                ></ScalarIndicator>
              </div>
            </template>
          </FetchJson>
          <FetchJson :url="urls.documentNotRegistered.value">
            <template #default="{ json, loading }">
              <div v-show="filter.mode === modes.allTime">
                <ScalarIndicator
                  v-if="!loading"
                  title="Не размещены из ИСОГД"
                  :value="json.value"
                ></ScalarIndicator>
              </div>
            </template>
          </FetchJson>
          <FetchJson :url="urls.documentRegistrationDeadlineCompliance.value">
            <template #default="{ json, loading }">
              <div v-if="!loading" style="flex-basis: 360px">
                <DonutChart
                  :series="json.map((o) => (o.values.length ? o.values[0] : 0))"
                  :labels="labels"
                  :colors="colors"
                  :height="90"
                  :legendOffsetX="85"
                  :legendOffsetY="-10"
                  :tooltipTitleFormatter="() => 'Количество документов: '"
                />
              </div>
            </template>
          </FetchJson>
        </div>
      </section>
      <section class="box box--small-padding">
        <h2 class="box__header title-24">В среднем за день</h2>
        <div class="layout--horizontal">
          <FetchJson :url="urls.indicatorDocumentInboxAverage.value">
            <template #default="{ json, loading }">
              <ScalarIndicator
                v-if="!loading"
                title="Направлено на размещение"
                :value="json.value"
              ></ScalarIndicator>
            </template>
          </FetchJson>
          <FetchJson :url="urls.indicatorDocumentRegisteredAverage.value">
            <template #default="{ json, loading }">
              <ScalarIndicator
                v-if="!loading"
                title="Размещено документов"
                :value="json.value"
              ></ScalarIndicator>
            </template>
          </FetchJson>
        </div>
      </section>
    </div>
    <section class="layout--vertical">
      <h2 class="visually-hidden">Графики</h2>
      <DocumentDistributionByPeriodChart :filter="filter" />
      <div v-show="!filter.territory.alias">
        <DocumentDistributionByTerritoryChart :filter="filter" />
      </div>
    </section>
  </Layout>
</template>

<script>
import { computed } from "vue";
import useGisogdFilter from "@/components/gisogd/filter";
import modes from "@/modules/datePickerModes";
import { dateToString } from "@/modules/date";

import Layout from "./Layout";
import DocumentDistributionByPeriodChart from "@/components/gisogd/DocumentDistributionByPeriodChart";
import DocumentDistributionByTerritoryChart from "@/components/gisogd/DocumentDistributionByTerritoryChart";
import ScalarIndicator from "@/components/infoblocks/ScalarIndicator";
import DonutChart from "@/components/common/DonutChart";
import FilterPanel from "@/components/common/FilterPanel";

const labels = ["В срок", "С нарушением сроков"];
const colors = ["#47A0FB", "#FCC8C2"];

export default {
  components: {
    Layout,
    FilterPanel,
    ScalarIndicator,
    DocumentDistributionByPeriodChart,
    DocumentDistributionByTerritoryChart,
    DonutChart,
  },
  setup() {
    const { filter, setFilter } = useGisogdFilter();
    const urls = {
      documentNotRegistered: computed(
        () =>
          `gisogd/document-not-registered?territory=${
            filter.value.territory.alias || ""
          }` // &salt=${filter.from.value.getTime() + filter.to.value.getTime()}
      ),
      documentPendingRegistration: computed(
        () =>
          `gisogd/document-pending-registration?territory=${
            filter.value.territory.alias || ""
          }` // &salt=${filter.from.value.getTime() + filter.to.value.getTime()}
      ),
      documentRegistrationDeadlineCompliance: computed(
        () =>
          `gisogd/document-registration-deadline-compliance?from=${dateToString(
            filter.value.from
          )}&to=${dateToString(filter.value.to)}&territory=${
            filter.value.territory.alias || ""
          }`
      ),
      documentRegisteredTotalUnfiltered: computed(
        () =>
          `gisogd/document-registered-total?from=${dateToString(
            filter.value.from
          )}&to=${dateToString(filter.value.to)}&territory=${
            filter.value.territory.alias || ""
          }`
      ),
      indicatorDocumentRegisteredAverage: computed(
        () =>
          `gisogd/document-registered-average?from=${dateToString(
            filter.value.from
          )}&to=${dateToString(filter.value.to)}&territory=${
            filter.value.territory.alias || ""
          }`
      ),
      indicatorDocumentInboxAverage: computed(
        () =>
          `gisogd/document-inbox-average?from=${dateToString(
            filter.value.from
          )}&to=${dateToString(filter.value.to)}&territory=${
            filter.value.territory.alias || ""
          }`
      ),
    };

    return {
      modes,
      filter,
      urls,
      setFilter,
      labels,
      colors,
    };
  },
};
</script>

<style lang="scss">
.indicators {
}
.indicators.layout--horizontal {
  align-items: stretch;
}
</style>
